export enum VehicleConditionType {
  NEW = 'NEW',
  USED = 'USED',
  CPO = 'CPO',
}
